document.addEventListener('DOMContentLoaded', () => {
  const items = [...document.querySelectorAll('.tap-header-v2__item[data-mega]')];
  const closeAll = (except) => items.forEach((item) => {
    if (item !== except) {
      item.classList.remove('is-open');
      const button = item.querySelector('.tap-header-v2__trigger');
      if (button) button.setAttribute('aria-expanded', 'false');
    }
  });

  items.forEach((item) => {
    const button = item.querySelector('.tap-header-v2__trigger');
    if (!button) return;
    const open = () => {
      closeAll(item);
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    };
    button.addEventListener('click', (event) => {
      event.preventDefault();
      item.classList.contains('is-open') ? close() : open();
    });
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) close();
    });
  });

  let drawer = document.querySelector('.tap-mobile-v2__drawer');
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  const openButton = document.querySelector('[data-tap-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-tap-drawer-close]');
  let lockedScrollY = 0;

  const setDrawer = (state) => {
    if (!drawer) return;

    if (state) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = `-${lockedScrollY}px`;
    }

    drawer.classList.toggle('is-open', state);
    drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
    document.documentElement.classList.toggle('tap-lock', state);
    document.body.classList.toggle('tap-lock', state);

    if (state) {
      window.requestAnimationFrame(() => drawer.querySelector('.tap-mobile-v2__close')?.focus());
    } else {
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
      openButton?.focus();
    }
  };

  const mobileCartButton = document.querySelector('[data-tap-mobile-cart]');
  mobileCartButton?.addEventListener('click', (event) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

    event.preventDefault();
    if (drawer?.classList.contains('is-open')) setDrawer(false);
    cartDrawer.open(mobileCartButton);
  });

  mobileCartButton?.addEventListener('keydown', (event) => {
    if (event.code.toUpperCase() !== 'SPACE') return;
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

    event.preventDefault();
    cartDrawer.open(mobileCartButton);
  });

  openButton?.addEventListener('click', () => setDrawer(true));
  closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
      if (drawer?.classList.contains('is-open')) setDrawer(false);
    }
  });

document.querySelectorAll('.tap-mobile-v2__main').forEach((button) => {
  const group = button.closest('.tap-mobile-v2__group');
  const title = button.querySelector('span')?.textContent.trim().toLowerCase();

  // Open Shop by Concern by default. It remains fully collapsible on click.
  if (title === 'shop by concern') {
    group.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  }

  button.addEventListener('click', () => {
    const state = !group.classList.contains('is-open');

    group.parentElement.querySelectorAll('.tap-mobile-v2__group.is-open').forEach((openGroup) => {
      if (openGroup !== group) {
        openGroup.classList.remove('is-open');
        openGroup.querySelector('.tap-mobile-v2__main')?.setAttribute('aria-expanded', 'false');
      }
    });

    group.classList.toggle('is-open', state);
    button.setAttribute('aria-expanded', state ? 'true' : 'false');
  });
});

  /* Remove classes/spacers left by older V2.1–V2.3 scripts. */
  document.documentElement.classList.remove('tap-fixed-stack-ready');
  document.documentElement.style.removeProperty('--tap-announcement-height');
  document.documentElement.style.removeProperty('--tap-announcement-offset');
  document.documentElement.style.removeProperty('--tap-fixed-header-height');

  document.querySelectorAll('.tap-header-fixed-spacer').forEach((spacer) => spacer.remove());
  document.querySelectorAll('.tap-header-wrapper.tap-header-fixed-active').forEach((header) => {
    header.classList.remove('tap-header-fixed-active');
    delete header.dataset.tapFixedReady;
  });
});

/* TAP V2.6 — fixed-on-threshold sticky header.
   This does not depend on the announcement app's HTML or class names. */
(() => {
  const initTapStickyHeader = () => {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader || sectionHeader.dataset.tapStickyReady === 'v26') return;

    sectionHeader.dataset.tapStickyReady = 'v26';

    document.documentElement.classList.remove('tap-fixed-stack-ready');
    sectionHeader.classList.remove('tap-header-is-fixed');
    document.querySelectorAll('.tap-header-fixed-spacer, .tap-header-scroll-spacer').forEach((node) => node.remove());
    document.querySelectorAll('.tap-header-wrapper.tap-header-fixed-active').forEach((node) => {
      node.classList.remove('tap-header-fixed-active');
      delete node.dataset.tapFixedReady;
    });

    const spacer = document.createElement('div');
    spacer.className = 'tap-header-scroll-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    sectionHeader.insertAdjacentElement('afterend', spacer);

    let threshold = 0;
    let headerHeight = 0;
    let ticking = false;

    const measure = () => {
      const wasFixed = sectionHeader.classList.contains('tap-header-is-fixed');

      if (wasFixed) {
        sectionHeader.classList.remove('tap-header-is-fixed');
        spacer.classList.remove('is-active');
        spacer.style.height = '0px';
      }

const rect = sectionHeader.getBoundingClientRect();
headerHeight = Math.ceil(rect.height);

/* Start fixing only after the header has completely scrolled away */
threshold = Math.max(
  1,
  Math.round(rect.top + window.scrollY + headerHeight)
);

spacer.style.height = '0px';

update();
    };

    const update = () => {
      ticking = false;
      const shouldFix = window.scrollY >= threshold;

sectionHeader.classList.toggle('tap-header-is-fixed', shouldFix);
spacer.classList.toggle('is-active', shouldFix);

if (shouldFix) {
  spacer.style.height = `${headerHeight}px`;
  sectionHeader.classList.remove('shopify-section-header-hidden', 'animate');
  sectionHeader.classList.add('shopify-section-header-sticky');
} else {
  spacer.style.height = '0px';
  sectionHeader.classList.remove('shopify-section-header-sticky');
}
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    measure();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('orientationchange', measure, { passive: true });
    window.addEventListener('load', measure, { once: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => {
        headerHeight = Math.ceil(sectionHeader.getBoundingClientRect().height);
        if (sectionHeader.classList.contains('tap-header-is-fixed')) {
          spacer.style.height = `${headerHeight}px`;
        } else {
          measure();
        }
      });
      observer.observe(sectionHeader);
    }

    setTimeout(measure, 250);
    setTimeout(measure, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTapStickyHeader, { once: true });
  } else {
    initTapStickyHeader();
  }
})();

/* TAP cart count bridge
 * The premium header has separate desktop and mobile cart links. Shopify's
 * AJAX cart sections refresh #cart-icon-bubble only, so mirror that count to
 * the custom mobile badge whenever the desktop cart markup changes.
 */
(() => {
  let desktopCartObserver = null;
  let observedDesktopCart = null;

  const readDesktopCartCount = () => {
    const desktopCart = document.querySelector('#cart-icon-bubble');
    if (!desktopCart) return null;

    const countElement =
      desktopCart.querySelector('.tap-header-v2__count') ||
      desktopCart.querySelector('.cart-count-bubble [aria-hidden="true"]') ||
      desktopCart.querySelector('.cart-count-bubble');

    if (!countElement) return 0;

    const parsedCount = parseInt((countElement.textContent || '').replace(/[^0-9]/g, ''), 10);
    return Number.isNaN(parsedCount) ? 0 : parsedCount;
  };

  const syncMobileCartCount = (forcedCount) => {
    const mobileCartLinks = document.querySelectorAll('[data-tap-mobile-cart]');
    if (!mobileCartLinks.length) return;

    const desktopCount = typeof forcedCount === 'number' ? forcedCount : readDesktopCartCount();
    if (desktopCount === null) return;

    mobileCartLinks.forEach((mobileCartLink) => {
      let badge = mobileCartLink.querySelector('.tap-mobile-v2__badge');

      if (desktopCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'tap-mobile-v2__badge';
          mobileCartLink.appendChild(badge);
        }

        const nextText = String(desktopCount);
        if (badge.textContent !== nextText) badge.textContent = nextText;
        if (badge.hidden) badge.hidden = false;
        mobileCartLink.setAttribute('aria-label', `Cart, ${desktopCount} ${desktopCount === 1 ? 'item' : 'items'}`);
      } else {
        if (badge) badge.remove();
        mobileCartLink.setAttribute('aria-label', 'Cart, empty');
      }
    });
  };

  const observeDesktopCart = () => {
    const desktopCart = document.querySelector('#cart-icon-bubble');

    if (!desktopCart) {
      syncMobileCartCount(0);
      return;
    }

    if (desktopCart === observedDesktopCart && desktopCartObserver) {
      syncMobileCartCount();
      return;
    }

    if (desktopCartObserver) desktopCartObserver.disconnect();

    observedDesktopCart = desktopCart;
    desktopCartObserver = new MutationObserver(() => syncMobileCartCount());
    desktopCartObserver.observe(desktopCart, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    syncMobileCartCount();
  };

  window.TAPCartCount = {
    sync: syncMobileCartCount,
    observe: observeDesktopCart,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDesktopCart, { once: true });
  } else {
    observeDesktopCart();
  }

  document.addEventListener('shopify:section:load', observeDesktopCart);
  document.addEventListener('cart:updated', () => {
    observeDesktopCart();
    syncMobileCartCount();
  });
})();
